import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import BrandStorySection from "./components/BrandStorySection";
import LookbookSection from "./components/LookbookSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import InstagramFeedSection from "./components/InstagramFeedSection";
import WhatsAppCTASection from "./components/WhatsAppCTASection";
import BulkOrderSection from "./components/BulkOrderSection";
import Footer from "./components/Footer";
import WhatsAppFloating from "./components/WhatsAppFloating";
import CataloguePage from "./pages/CataloguePage";
import AnalyticsPage from "./pages/AnalyticsPage";

function LandingPage() {
  return (
    <>
      <HeroSection />
      <BrandStorySection />
      <LookbookSection />
      <TestimonialsSection />
      <FAQSection />
      <InstagramFeedSection />
      <WhatsAppCTASection />
      <BulkOrderSection />
    </>
  );
}

function ScrollToTop() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <div className="App bg-[#F5F0E8]">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/catalogue" element={<><ScrollToTop /><CataloguePage /></>} />
            <Route path="/analytics" element={<><ScrollToTop /><AnalyticsPage /></>} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloating />
      </div>
    </BrowserRouter>
  );
}

export default App;
